// Vue
import { Component } from "vue-property-decorator";

// Template
import template from "./template.vue";
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";
import { Headline } from "#/components/headline/Headline";

@Component({
  name: "DownloadModule",
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
  },
})
export class DownloadModule extends ModuleBase {
  public lang: string = "de";

  getBackgroundColorFromInstance(instance: object) {
    return instance["section_color"]["color"];
  }

  get downloads() {
    return this.instance["downloads"].slice();
  }

  downloadLink(download) {
    if (
      download.doc !== "" &&
      this.getTranslatedImage(download.doc, this.lang, "full")
    ) {
      return this.getTranslatedImage(download.doc, this.lang, "full");
    } else {
      return download.link;
    }
  }

  filename(download) {
    let fn = download.label;
    let dl = this.downloadLink(download);
    let ending = dl.split(".").pop();
    return fn + "." + ending;
  }

  stats(download) {
    let stat = "";

    if (
      typeof download.doc === "object" &&
      download.doc[this.lang] !== null &&
      Array.isArray(download.doc[this.lang]) &&
      (download.doc[this.lang] as any).length > 0
    ) {
      if (download.doc[this.lang] && download.doc[this.lang].file_type !== "")
        stat +=
          download.doc[this.lang].file_type +
          (download.doc[this.lang].file_size !== "" ? ", " : "");

      if (download.doc[this.lang] && download.doc[this.lang].file_size !== "")
        stat += download.doc[this.lang].file_size;
    } else {
      if (download.doctype !== "") {
        stat += download.doctype + (download.docsize !== "" ? ", " : "");
      }

      if (download.docsize !== "") {
        stat += download.docsize;
      }
    }
    return stat;
  }
}
